/** Invoice helpers shared by the invoice pages and other features. */
import { useQuery } from "@tanstack/react-query";
import { type InvoiceResponse } from "@offertli/shared";
import { apiGet } from "../../lib/api.js";
import { StatusBadge } from "../../components/StatusBadge.js";

export function invoiceLabel(
  invoice: Pick<InvoiceResponse, "number" | "kind">,
  t: (key: string) => string,
) {
  return (
    invoice.number ??
    (invoice.kind === "credit_note"
      ? t("invoice.draftCreditNote")
      : t("invoice.draftNumber"))
  );
}

export function useInvoice(id: string | undefined) {
  return useQuery({
    queryKey: ["invoice", id],
    queryFn: () =>
      apiGet<{ data: InvoiceResponse }>(`/invoices/${id}`).then(
        (response) => response.data,
      ),
    enabled: Boolean(id),
  });
}

export function PaymentBadge({ invoice }: { invoice: InvoiceResponse }) {
  if (invoice.status === "draft" || invoice.status === "cancelled")
    return <StatusBadge status={invoice.status} />;
  if (invoice.kind === "credit_note") return <StatusBadge status="issued" />;
  return (
    <span className="inline-flex flex-wrap gap-1">
      <StatusBadge status={invoice.paymentStatus} />
      {invoice.isOverdue ? <StatusBadge status="overdue" /> : null}
    </span>
  );
}
